import { render, staticRenderFns } from "./SizeScaleForm.vue?vue&type=template&id=ecb0d6ba"
import script from "./SizeScaleForm.vue?vue&type=script&lang=js"
export * from "./SizeScaleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports